module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-1800.3e718659.jpg";